import { BaseRouteService } from 'core/services';

class MultiPackageProductRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'multi-package-products/';
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', {sourceOfChange});
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, {sourceOfChange});
	}
}

export default MultiPackageProductRouteService;
